/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import React from 'react';

import { KeydownEventCodes } from '@powdr/constants';

import {
  StyledDesktopTab, StyledMobileTab, StyledMobileIcon, TabButton,
  MobileTabItemWrapper,
} from './styles';

export const BookingWidgetTab = ({
  mobile = false,
  label,
  colorProfile = '',
  children = null,
  isSingleTab = false,
  ...props
}) => {
  const key = mobile ? `mobile-tab-${label}` : `desktop-tab-${label}`;
  const TabComponent = mobile ? StyledMobileTab : StyledDesktopTab;

  return mobile ? (
    <MobileTabItemWrapper>
      <TabComponent>
        <TabButton
          tabIndex="0"
          key={key}
          {...props}
          $isSingleTab={isSingleTab}
          colorProfile={colorProfile}
          onClick={() => props.onClick()}
          onKeyDown={(e) => (e.keyCode === KeydownEventCodes.ENTER) && props.onClick()}
        >
          {label}
          <StyledMobileIcon className="mobile-icon" name="ui-chevron-down" width="25" />
        </TabButton>
      </TabComponent>
      {children}
    </MobileTabItemWrapper>
  ) : (
    <TabComponent>
      <TabButton
        tabIndex="0"
        key={key}
        {...props}
        colorProfile={colorProfile}
        onClick={() => props.onClick()}
        onKeyDown={(e) => (e.keyCode === KeydownEventCodes.ENTER) && props.onClick()}
      >
        {label}
      </TabButton>
    </TabComponent>
  );
};

BookingWidgetTab.propTypes = {
  mobile: PropTypes.bool,
  label: PropTypes.string.isRequired,
  colorProfile: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  isSingleTab: PropTypes.bool,
};
